import "../css/DetailGrid.css";

function isEmptyValue(value) {
  return value === null || value === undefined || value === "" || value === "-";
}

function DetailField({ field }) {
  const { label, value, icon, wide, mono } = field;
  const empty = isEmptyValue(value);
  return (
    <div className={`detail-field${wide ? " detail-field-wide" : ""}`}>
      {icon ? (
        <span className="detail-field-icon">
          <i className={`fa ${icon}`}></i>
        </span>
      ) : null}
      <div className="detail-field-body">
        <span className="detail-field-label">{label}</span>
        <span className={`detail-field-value${empty ? " detail-field-empty" : ""}${mono ? " detail-field-mono" : ""}`}>
          {empty ? "—" : value}
        </span>
      </div>
    </div>
  );
}

// Dynamic, minimalist replacement for stacked "<strong>Label:</strong> value" paragraphs.
// Pass `sections` (array of { title, fields }) to group related fields, or a flat `fields` array.
function DetailGrid({ sections, fields }) {
  const groups = sections || [{ fields: fields || [] }];
  return (
    <div className="detail-grid-wrapper">
      {groups.map((group, index) => {
        const visibleFields = (group.fields || []).filter(Boolean);
        if (visibleFields.length === 0) return null;
        return (
          <div className="detail-grid-section" key={group.title || index}>
            {group.title ? <h6 className="detail-grid-section-title">{group.title}</h6> : null}
            <div className="detail-grid">
              {visibleFields.map((field) => (
                <DetailField field={field} key={field.label} />
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default DetailGrid;
